var utils = require('./tripletrax.utils.js');
var ajax = require('./tripletrax.ajax.js');
var views = require('./tripletrax.views.js');
var access = require('./tripletrax.access.js');

function loadPatientlist(loadIDATData) {

    return $.Deferred(function (defer) {
        var patients = null;
        $('#table_patientlist').find('.dataTables_empty').text('').append('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');
        $('#table_monitoring_patientlist').find('.dataTables_empty').text('').append('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');

        var data = 'show_patients_active=' + $('[name="show_patients_active"]').is(':checked') +
            '&' + 'hide_patients_released=' + $('[name="hide_patients_released"]').is(':checked') +
            '&' + 'show_patients_incomplete_master_data=' + $('[name="show_patients_incomplete_master_data"]').is(':checked') +
            '&' + 'show_patients_incomplete_course_data=' + $('[name="show_patients_incomplete_course_data"]').is(':checked') +
            '&' + 'show_patients_incomplete_course_data_year=' + $('.tt-incomplete-course-data-year').select2('val');

        ajax.ajaxCallDeferred('doc/patient/patientlist/patients/facility/' + views.getFacilityId() + '/model/' + views.getModelId(), 'GET', data, false).done(function (data) {
            if (ajax.ajaxSucceeded(data)) {

                patients = data;
                loadIDATPatientList(views.getFacilityId(), views.getModelId(), loadIDATData).done(function () {

                    // Ist die IDAT nicht erreichbar, so können keine neuen Patienten angelegt werden
                    if ($('#locale').data().pseudonymization === 'none') {
                        $('#content').find('.tt-add-idat-patient').removeClass('disabled');
                        $('#content').find('.tt-add-idat-patient').removeAttr('disabled');
                    } else {
                        if (utils.GLOBALS.idatPatients === null) {
                            $('#content').find('.tt-add-idat-patient').addClass('disabled');
                            $('#content').find('.tt-add-idat-patient').prop('disabled', 'disabled');
                        } else if (!$('#content').find('.tt-add-idat-patient').hasClass('no-rights')) {
                            $('#content').find('.tt-add-idat-patient').removeClass('disabled');
                            $('#content').find('.tt-add-idat-patient').removeAttr('disabled');
                        }
                    }
                    defer.resolve(patients);
                });
            } else {
                defer.reject();
            }
        });

    }).promise();
}

function getPatientlist(patients) {

    idatPatients = utils.GLOBALS.idatPatients;
    var data = [];
    if (idatPatients === null) {
        jQuery.each(patients, function (i, patient) {

            patient["patientname"] = trans('tripletrax.anonym');
            patient["prename"] = trans('tripletrax.anonym');
            patient["street"] = trans('tripletrax.anonym');
            patient["postal_code"] = trans('tripletrax.anonym');
            patient["city"] = trans('tripletrax.anonym');
            patient["birth_name"] = trans('tripletrax.anonym');
            patient["birth_city"] = trans('tripletrax.anonym');

            data.push(patient);
        });
    } else {
        var genderMatchValues = $('#gender_values').data().matchValues;

        jQuery.each(patients, function (i, patient) {
            jQuery.each(idatPatients, function (k, idat) {
                if (idat["ids"][0]["idString"] === patient.pseudonym) {

                    patient["patientname"] = idat["fields"]["nachname"];
                    patient["prename"] = idat["fields"]["vorname"];
                    patient["birth_date"] = idat["fields"]["geburtsjahr"] + '-' + ('00' + idat["fields"]["geburtsmonat"]).substr(idat["fields"]["geburtsmonat"].length) + '-' + ('00' + idat["fields"]["geburtstag"]).substr(idat["fields"]["geburtstag"].length);
                    patient["birth_date_format"] = 'full';
                    patient["gender"] = idat["fields"]["geschlecht"];
                    if (patient["gender"] === 'M' && !utils.isUndefined(genderMatchValues["male"])) {
                        patient["gender"] = genderMatchValues["male"];
                    } else if (patient["gender"] === 'W' && !utils.isUndefined(genderMatchValues["female"])) {
                        patient["gender"] = genderMatchValues["female"];
                    }
                    patient["street"] = idat["fields"]["strasse"];
                    patient["postal_code"] = idat["fields"]["plz"];
                    patient["city"] = idat["fields"]["ort"];
                    patient["birth_name"] = idat["fields"]["geburtsname"];
                    patient["birth_city"] = idat["fields"]["geburtsort"];

                    data.push(patient);
                    return false;
                }
            });
        });
    }
    return data;
}

function loadExaminationList(patientid, patientIsActive, patientIsLocked, url) {

	var questionnaires = views.getQuestionnaires();
	var data = '';

	if (Object.keys(questionnaires).length > 0) {

		for (var id in questionnaires) {
			if (data !== '') {
				data += '|';
			}
			data += id;
		}
	}
    return ajax.ajaxCallDeferred(url.substring(0, url.lastIndexOf('/patient/') + 8) + "/" + patientid + "/state/" + patientIsActive + "/locked/" + patientIsLocked, 'GET', 'questionnaires=' + data, false);
}

function getExaminationList(data) {

    var examinationData = [];

    jQuery.each(data, function (i, exam) {
        exam.examinationdate = utils.stringToDate(exam.examinationdate);
        examinationData.push(exam);
    });
    return examinationData;
}

function loadAgreementList(patientid, patientIsLocked) {

    $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-dialog-agreement-open').addClass('disabled');
    var newTableUrl = $('#table_patient_agreement').dataTable().data().tableUrl.substring(0, $('#table_patient_agreement').dataTable().data().tableUrl.lastIndexOf('/')) + "/" + patientid + "/locked/" + patientIsLocked +  "/datatable";
    return ajax.ajaxCallDeferred(newTableUrl, 'GET', null, false).done(function (data) {
        $('#table_patient_agreement').dataTable().api().clear().rows.add(data).draw();

        $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-delete').addClass('disabled');
        $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-show-document').addClass('disabled');
        $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-print-document').addClass('disabled');
        $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-dialog-agreement-open').removeClass('disabled');
    });
}

function checkEndingAgreements(patientid) {
    return $.Deferred(function (defer) {
        var url = 'doc/patient/patient/agreement/facility/' + views.getFacilityId() + '/patient/' + patientid + '/ending';
        ajax.ajaxCallDeferred(url, 'GET', null, false).done(function (data) {
            var validAgreements = $.parseJSON(data);
            if (Object.keys(validAgreements).length === 1) {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.ending_agreement_existing'),
                    content: Lang.get('tripletrax.ending_agreement_existing_desc'),
                    buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                }, function (ButtonPressed) {
                    if (ButtonPressed === Lang.get('tripletrax.yes')) {
                        $('#table_patient_agreement_create_form').find('.tt-ending-agreement-id').val(Object.keys(validAgreements)[0]);
                        $('#table_patient_agreement_create_form').find('.tt-new-valid-agreement-id').val(validAgreements[Object.keys(validAgreements)[0]]);
                        $('#table_patient_agreement_create_form').find('.tt-show-examination-dialog').val('true');
                        $('#table_patient_agreement').parents('.tt-content-datatable').find('.tt-dialog-agreement-open').click();
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                });
            } else if (Object.keys(validAgreements).length > 1) {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.ending_agreement_existing'),
                    content: Lang.get('tripletrax.ending_agreements_existing_desc'),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                });
                defer.resolve(false);
            } else {
                defer.resolve(false);
            }
        });
    }).promise();
}

function setData(element, data, resetForm, doEqualizeControls, doIntegrityCheckAndCalculation, isOwnFacility, isNewExamination, doNotOpenAccordionPanel, doCompletenessCheck, setAllColumns, isLocked) {
    // console.log(element[0].id);
    var request = $.Deferred(function(defer) {
        //console.time("setData");

		doCompletenessCheck = !utils.isUndefined(doCompletenessCheck) ? doCompletenessCheck : true;
        doNotOpenAccordionPanel = !utils.isUndefined(doNotOpenAccordionPanel) ? doNotOpenAccordionPanel : false;
        setAllColumns = !utils.isUndefined(setAllColumns) ? setAllColumns : true;
        isLocked = !utils.isUndefined(isLocked) ? isLocked : false;
        $(element).addClass('hide');
        $(element).find('form').addClass('tt-set-data');
        if (doNotOpenAccordionPanel) {
            $(element).find('form').addClass('tt-do-not-open-accordion-panel');
        }

        if (!utils.isUndefined(data)) {

            // console.time("setData1");
			// console.time('setControlsDependingOnRights: setData');
            access.setControlsDependingOnRights(element, isOwnFacility, isLocked);
			// console.timeEnd('setControlsDependingOnRights: setData');

            if (resetForm) {
                resetForms(element, true, true);
            }

            // console.timeEnd("setData1");
            // console.time("setData2");

            var databaseTables = element.find('[data-database-table-name]');
            jQuery.each(databaseTables, function (i, table) {
                if ($(table).hasClass('tt-accordion')) {
                    $(table).find('.panel-group').empty();
                    $(table).find('.tt-accordion-hidden-panel-counter').val(0);
                } else {
                    $(table).dataTable().fnClearTable();
                    $(table).parents('.tt-content-datatable').find('.tt-hidden-list-entry-counter').val(0);
                }
                if ($(table).hasClass('tt-accordion')) {
                    var counter = 0;
                    var tableName = $(table).data().databaseTableName;
                    var activationName = $(table).data().activationName;
                    while (tableName + '_rowid__' + counter in data) {

                        views.addAccordionGroup($(table), data[tableName + '_rowid__' + counter], false, isOwnFacility, false, isLocked);
                        counter++;
                    }

                    if (counter === 0 && (activationName in data)) {
                        if ($('[name="' + activationName + '"][data-activation="1"]').length && $('[name="' + activationName + '"][data-activation="1"]').val() === data[activationName].toString()) {
                            views.addAccordionGroup($(table), 0, true, isOwnFacility, true, isLocked);
                        }
                    }
                }
            });


            // console.timeEnd("setData2");
            // console.time("setData3");
            var questionnaireElements = element.find('.tt-is-editable-calculation');
				jQuery.each(questionnaireElements, function(i, questionnaire) {
				    if (!utils.isUndefined(questionnaire.dataset.calculatedValue)) {
						questionnaire.dataset.calculatedValue = '';
                    }
				});

            views.setValues(element, data, doEqualizeControls, false, true, setAllColumns);

            // console.timeEnd("setData3");
            // console.time("setData4");

            jQuery.each(databaseTables, function (i, table) {

                if (!$(table).hasClass('tt-accordion')) {
                    var counter = 0;
                    var tableName = $(table).data().databaseTableName;
                    while (tableName + '_rowid__' + counter in data) {

                        views.addListEntry($(table), data[tableName + '_rowid__' + counter], data, isOwnFacility, false, isLocked);
                        counter++;
                    }

                    if (counter === 0 && (table.id.substr(5) in data)) {
                        if ($('[name="' + table.id.substr(5) + '"][data-activation="1"]').length && $('[name="' + table.id.substr(5) + '"][data-activation="1"]').val() === data[table.id.substr(5)].toString()) {
                            views.addListEntry($(table), 0, null, isOwnFacility, true, isLocked);
                        }
                    }
                }
            });

            // console.timeEnd("setData4");
            // console.time("setData5");

            // Nach Setzen der Werte Integritäten prüfen, Vollständigkeit und Berechnungen durchführen
            if (doIntegrityCheckAndCalculation) {
                var course = utils.getCourse();
                var master = utils.getMaster();
                if ($(element).parents('#content-detail-course').length) {
                    if (isNewExamination) {
						setIntegrityAndCalculations(master);
						setIntegrityAndCalculations(course);
                    } else {
						setIntegrityAndCalculations(element);
                    }
                } else if ($(element).parents('#content-detail-master').length) {
                    if (isNewExamination) {
						setIntegrityAndCalculations(master);
                    } else {
						setIntegrityAndCalculations(element);
                    }
                } else {
					setIntegrityAndCalculations(element);
                }
            }
            if (doCompletenessCheck) {
				views.setCompleteness(null, views.getFormDataForAjaxCall(true, true, false), false, 1);
            }
            // console.timeEnd("setData5");
        }
        $(element).removeClass('hide');
        $(element).find('form').removeClass('tt-set-data');
        $(element).find('form').removeClass('tt-do-not-open-accordion-panel');
        $(element).addClass('data-loaded');

		$(element).find('form').trigger('rescan.areYouSure');
		$(element).find('form').trigger('setDirtyStatusFalse');
        //console.timeEnd("setData");
        defer.resolve();
    });
    utils.GLOBALS.runningAjaxRequests.push(request);

    return request;
}

function setIntegrityAndCalculations(element) {

    // Integritätsprüfung an dieser Stelle nicht machen!!!
    // TODO: Bei Änderung eines Wertes, welcher keinen Bezug zu Untersuchung hat, die Integritätsprüfung für alle Untersuchungen durchführen und speichern
    // dann hat sich die Prüfung hier erledigt!!!

    var formData = views.getFormDataForAjaxCall(true, true, false);

    var integrityArray = [];
    jQuery.each(element.find(".tt-check-integrity"), function (i, subelement) {
        if ($(subelement).is(':radio')) {
            if ($(subelement).parent().is(':first-child')) {
                integrityArray.push($(subelement));
            }
        } else {
            integrityArray.push($(subelement));
        }
    });
    if (integrityArray.length) {
        views.checkIntegrity(integrityArray, false, true, formData, false, false);
    }

    var calculationArray = [];
    jQuery.each(element.find(".tt-check-calculation"), function (i, subelement) {
        if ($(subelement).is(':radio') || $(subelement).is(':checkbox')) {
            if ($(subelement).is(':checked')) {
                calculationArray.push($(subelement));
            }
        } else {
            calculationArray.push($(subelement));
        }
    });
    if (calculationArray.length) {
        views.calculateValues(calculationArray, false, formData, false);
    }
}

function resetForms(element, resetSelect2, enableControls) {

    // console.log(element[0].id);
    // console.time('resetForms');
    if (element.find('form').length) {
        jQuery.each(element.find('form'), function (i, form) {
            // console.time('resetForms1');
            $(form).validate().resetForm();
            // console.timeEnd('resetForms1');
        });
    } else {
        element.find('input:checked').prop('checked', false);
    }
		// console.time('resetForms2');
        jQuery.each($(element).find('[name]'), function (i, val) {
            val.dataset.initValue = '';
            val.dataset.queryQuestion = '';
            val.dataset.queryAnswer = '';
            val.dataset.originalTitle = '';
        });
        $(element).find('.tt-tab-button span').text('');
        jQuery.each($(element).find('.tt-tab-button-group'), function (k, val) {
            $(val).find('input:checked').prop('checked', false);
            $(val).find('input[value="1"]').prop('checked', true);
            $(val).find('.tt-tab-button').removeClass('active');
            $(val).find('input[value="1"]').parent().addClass('active');
            views.showColumn($($(val).parents('.tt-column')[0]).find('.tt-column-panel,.tt-panel'), 1, false);
        });
		// console.timeEnd('resetForms2');
		// console.time('resetForms3');
        if (!$(element).hasClass('tt-no-reset-hidden-input')) {
            $(element).find('input[type="hidden"]:not([data-no-reset="no-reset-value"])').val("");
        }
		// console.timeEnd('resetForms3');
		// console.time('resetForms4');
        if (resetSelect2) {
            $(element).find('.tt-select2:not(.tt-data-collection-type,.tt-questionnaire-project)').val(null).trigger('change.select2');
		}
		// console.timeEnd('resetForms4');
		// console.time('resetForms5');
        jQuery.each($(element).find('input.tt-view-radio[data-inactive="true"]'), function (k, val) {
            $(val).parent().addClass('hide');
        });
		// console.timeEnd('resetForms5');
		// console.time('resetForms6');
        jQuery.each($(element).find('[data-integrity-popover]'), function (k, val) {
            views.resetControl($($(val).parents('.row')[0]).find('[name]'), true);
        });
		// console.timeEnd('resetForms6');
		// console.time('resetForms7');
        if (enableControls) {
            //console.time('resetForms1');
            jQuery.each($(element).find('.tt-sub-control,.tt-unlock-for-editing'), function (i, val) {
                views.setControlEnabled($(val), false, false, false, true, false);
            });
            //console.timeEnd('resetForms1');
            //console.time('resetForms2');

            // Falls Feld aufgrund der Rechte nicht aktiv war, muss es hier wieder aktiv gesetzt werden (z.B. man besitzt nur das Recht ändern aber nicht anlegen)
            jQuery.each($(element).find('[name]:not(.tt-sub-control,.tt-tab-button-control,.tt-unlock-for-editing,.tt-is-calculated:not(.tt-is-editable-calculation))'), function (i, val) {
				if ($(val).hasClass('tt-is-editable-calculation') && !utils.isUndefined(val.dataset.calculatedValue) && val.dataset.calculatedValue !== '') {
					return false;
                }
                if (access.getRight($(val), 'update') > 0 || access.getRight($(val), 'write') > 0) {
                    views.setControlEnabled($(val), true, false, false, true, false);
                    if ($(val).hasClass('tt-view-input') || $(val).hasClass('tt-view-datepanel')) {
                        if ($(val).parents('.tt-view-input-label').find('button.btn-dropdown').length) {
                            views.setControlEnabled($(val).parents('.tt-view-input-label').find('button.btn-dropdown'), true, false, false, true, false);
                        }
                    }
                }
            });
            //console.timeEnd('resetForms2');
        }
		// console.timeEnd('resetForms7');
		// console.time('resetForms8');
        jQuery.each($(element).find('.tt-history'), function (i, val) {
            $(val)[0].dataset.content = '';
        });
		// console.timeEnd('resetForms8');
		// console.time('resetForms9');
        jQuery.each($(element).find('.tt-add-list-item:not(.tt-right-button-write),.tt-add-accordion-group:not(.tt-right-button-write)'), function (i, val) {
            $(val).addClass('disabled');
            $(val).prop('disabled', 'disabled');
        });
		// console.timeEnd('resetForms9');
		// console.time('resetForms10');
        jQuery.each($(element).find('.tt-view-input,.tt-view-datepanel'), function (i, input) {
            if (!utils.isUndefined(input.dataset) && !utils.isUndefined(input.dataset.defaultFormatValue) && input.dataset.defaultFormatValue !== '') {
                var changeDisabledState = $(input).parents('.tt-accordion').length <= 0 && (access.getRight(input, 'update') > 0 || access.getRight(input, 'write') > 0) && !$(input).hasClass('tt-unlock-for-editing') && (!$(input).hasClass('tt-is-calculated') || ($(input).hasClass('tt-is-editable-calculation') && (utils.isUndefined(input.dataset.calculatedValue) || input.dataset.calculatedValue === '')));
                utils.setValueForInputWithDropDownField($(input).parent(), input.dataset.defaultFormatValue, changeDisabledState);
            }
            if ($(input).hasClass('tt-view-datepanel')) {
                $(input).data('picker').setDate(null);
            }
        });
		// console.timeEnd('resetForms10');
		// console.time('resetForms11');
        $(element).find('ul.fa-ul').hide();
        $(element).find('.tt-column-panel,.tt-repetition-panel:not(.tt-repetition-column-panel)').hide();
        $(element).find('.tt-delete-list-item').addClass('disabled');
        $(element).find('.tt-btn-unlock-for-editing').find('i').removeClass('fa-unlock').addClass('fa-lock');
		// console.timeEnd('resetForms11');
		// console.time('resetForms12');
        if ($('#accordions_always_expanded').val() === '1') {
            $(element).find('.tt-accordion-panel-body').collapse('show');
            $(element).find('.tt-accordion-header').attr('disabled', 'disabled');
            $(element).find('.tt-accordion-header').find('.tt-icon-accordion').addClass('hide');
        } else {
            $(element).find('.tt-accordion-panel-body.in').collapse('toggle');
            $(element).find('.tt-accordion-header').addClass('collapsed');
            $(element).find('.tt-accordion-header').removeAttr('disabled');
            $(element).find('.tt-accordion-header').find('.tt-icon-accordion').removeClass('hide');
        }
		// console.timeEnd('resetForms12');
		// console.time('resetForms13');
        $(element).find('.tt-accordion-panel-body').removeClass('tt-in');
        $(element).find('[calculate-other-examinations]').removeAttr('calculate-other-examinations');
        $(element).find('[check-completeness-all-patient]').removeAttr('check-completeness-all-patient');
        $(element).find('[check-completeness-all-examination]').removeAttr('check-completeness-all-examination');
        $(element).find('.tt-cave-text').removeClass('tt-bold').removeClass('tt-underline').removeClass('tt-italic').addClass('hide');
        $(element).find('.tt-cave-text').css('color', 'black');
		// console.timeEnd('resetForms13');
		// console.time('resetForms14');
        $(element).find('.tt-btn-query[aria-describedby]').click();
		// console.timeEnd('resetForms14');
		// console.time('resetForms15');

        // Darf der Benutzer die Daten nur anonymisiert sehen, so müssen die Buttons zum Entsperren für die IDAT-Felder wieder entfernt werden
        $(element).find('.tt-btn-unlock-for-editing').removeClass('hide');
        $(element).find('.tt-btn-assume-examination-date').removeClass('hide');
        //jQuery.each($(element).find('.tt-btn-eraser'), function (i, val) {
        //  if (access.getRight($(val), 'delete') > 0) {
        //      $(element).find('.tt-btn-eraser').removeClass('hide');
        //  }
        //});
		// console.timeEnd('resetForms15');
		// console.time('resetForms16');
        if ((access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) && $('#locale').data().pseudonymization !== 'none') {
            $.each($(element).find('[data-match-field]'), function (i, element) {

                if (!utils.isUndefined(element.dataset) && !utils.isUndefined(element.dataset.matchField) && utils.isIDATField(element.dataset.matchField)) {
                    $(element).parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing,.tt-btn-assume-examination-date').addClass('hide');
                }
            });
        }
		// console.timeEnd('resetForms16');

	jQuery.each(element.find('form'), function (i, form) {
		// console.time('resetForms17');
        $(form).trigger('reset.areYouSure');
		// console.timeEnd('resetForms17');
		// console.time('resetForms18');
        $(form).trigger('setDirtyStatusFalse');
		// console.timeEnd('resetForms18');

    });
	// console.timeEnd('resetForms');
}

function loadIDATPatientList(facilityid, model, loadIDATData) {

    return $.Deferred(function (defer) {

        if (access.showPatientsAnonymized() === 0) {
            if (loadIDATData) {
                ajax.ajaxCallDeferred('doc/patient/patientlist/patients/facility/' + facilityid + '/model/' + model + '/idat', 'GET', null, false)
                    .done(function (data) {
                        if (ajax.ajaxSucceeded(data)) {
                            if (data !== null && data.tokenId !== '') {
                                ajax.ajaxCallDeferredExtended(data.url, 'GET', 'tokenId=' + encodeURIComponent(data.tokenId), false, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, false)
                                    .done(function (data) {
                                        if (ajax.ajaxSucceeded(data)) {
                                            utils.updateGlobals('idatPatients', data);
                                            defer.resolve();
                                        } else {
                                            utils.updateGlobals('idatPatients', null);
                                            defer.resolve();
                                        }
                                    });
                            } else {
                                utils.updateGlobals('idatPatients', null);
                                defer.resolve();
                            }
                        } else {
                            utils.updateGlobals('idatPatients', null);
                            defer.reject();
                        }
                    });
            } else {
                defer.resolve();
            }
        } else {
            utils.updateGlobals('idatPatients', null);
            defer.resolve();
        }
    }).promise();
}

function loadIDATPatientListWithPseudonym(pseudonyms) {

    var data = '';
    $.each(pseudonyms, function (i, pseudonym) {
        data += '&' + i + '=' + pseudonym;
    });

    return $.Deferred(function (defer) {

        var matchFields;
        var matchFieldDescriptions;

        ajax.ajaxCallDeferred('doc/patient/patientlist/patients/pseudonym/idat/model/' + $('.tt-export-data-collection-type').select2('val'), 'POST', data, false)
            .done(function (data) {
                if (ajax.ajaxSucceeded(data)) {
                    if (data !== null && data.tokenId !== '') {
                        matchFields = data.matchFields;
                        matchFieldDescriptions = data.matchFieldDescriptions;
                        ajax.ajaxCallDeferredExtended(data.url, 'GET', 'tokenId=' + encodeURIComponent(data.tokenId), false, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, false)
                            .done(function (data) {
                                if (ajax.ajaxSucceeded(data)) {
                                    if (!utils.isUndefined(matchFields)) {
                                        data.push(matchFields);
                                    }
                                    if (!utils.isUndefined(matchFieldDescriptions)) {
                                        data.push(matchFieldDescriptions);
                                    }
                                    defer.resolve(data);
                                } else {
                                    defer.reject();
                                }
                            });
                    }
                } else {
                    defer.reject();
                }
            });
    }).promise();
}

function addPatientToIDAT(prename, name, birthDate, gender, street, postalCode, city, birthName, birthCity) {

    return $.Deferred(function (defer) {
        ajax.ajaxCallDeferred('doc/patient/patient/idat', 'GET', null, false).done(function (data) {

            if (ajax.ajaxSucceeded(data)) {
                if (data !== null && data.tokenId !== '') {

                    var patientData = 'vorname=' + encodeURIComponent(prename.split('=')[0]);
                    patientData += '&nachname=' + encodeURIComponent(name.split('=')[0]);
                    var birthDateArray = birthDate.split('=')[0].split('-');
                    patientData += '&geburtstag=' + encodeURIComponent(birthDateArray[2]);
                    patientData += '&geburtsmonat=' + encodeURIComponent(birthDateArray[1]);
                    patientData += '&geburtsjahr=' + encodeURIComponent(birthDateArray[0]);
                    var genderArray = gender.split('=');
                    if (genderArray.length > 1 && genderArray[1] === 'female') {
                        patientData += '&geschlecht=' + encodeURIComponent('W');
                    } else if (genderArray.length > 1 && genderArray[1] === 'male') {
                        patientData += '&geschlecht=' + encodeURIComponent('M');
                    } else {
                        patientData += '&geschlecht=' + encodeURIComponent('U');
                    }
                    patientData += '&strasse=' + encodeURIComponent(street.split('=')[0]);
                    patientData += '&plz=' + encodeURIComponent(postalCode.split('=')[0]);
                    patientData += '&ort=' + encodeURIComponent(city.split('=')[0]);
                    patientData += '&geburtsname=' + encodeURIComponent(birthName.split('=')[0]);
                    patientData += '&geburtsort=' + encodeURIComponent(birthCity.split('=')[0]);
                    patientData += '&geburtsdatumdermutter=';
                    patientData += '&ambulanzen=';
                    patientData += '&sureness=false';

                    ajax.ajaxCallDeferredExtended(data.url + '?tokenId=' + encodeURIComponent(data.tokenId), 'POST', patientData, false, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, false).done(function (data) {
                        if (ajax.ajaxSucceeded(data)) {
                            defer.resolve(data.newId);
                        } else {
                            defer.reject();
                        }
                    })
                    .catch(function (data) {
                        if (data.status == '409') {
                            defer.resolve('409');
                        } else {
                            defer.resolve(null);
                        }
                    });
                }
            } else {
                defer.reject();
            }
        });
    }).promise();
}

function addPatientToIDATWithPseudonym(pseudonym) {

    return $.Deferred(function (defer) {
        ajax.ajaxCallDeferred('doc/patient/patient/idat/add/' + pseudonym, 'GET', null, false).done(function (data) {

            if (ajax.ajaxSucceeded(data)) {
                if (data !== null && data.tokenId !== '') {

                    ajax.ajaxCallDeferredExtended(data.url, 'GET', 'tokenId=' + encodeURIComponent(data.tokenId), false, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, false).done(function (data) {
                        if (ajax.ajaxSucceeded(data)) {
                            defer.resolve(data);
                        } else {
                            defer.reject();
                        }
                    })
                    .catch(function (data) {
                        defer.resolve(null);
                    });
                } else {
                    defer.resolve(null);
                }
            } else {
                defer.reject();
            }
        });
    }).promise();
}

function changePatientInIDAT(pseudonym, prename, name, birthDate, gender, street, postalCode, city, birthName, birthCity) {

    return $.Deferred(function (defer) {
        ajax.ajaxCallDeferred('doc/patient/patient/idat/change/' + pseudonym, 'GET', null, false).done(function (data) {
            if (ajax.ajaxSucceeded(data)) {
                if (data !== null && data.tokenId !== '') {

                    var patientData = 'vorname=' + encodeURIComponent(prename.split('=')[0]);
                    patientData += '&nachname=' + encodeURIComponent(name.split('=')[0]);
                    var birthDateArray = birthDate.split('=')[0].split('-');
                    patientData += '&geburtstag=' + encodeURIComponent(birthDateArray[2]);
                    patientData += '&geburtsmonat=' + encodeURIComponent(birthDateArray[1]);
                    patientData += '&geburtsjahr=' + encodeURIComponent(birthDateArray[0]);
                    var genderArray = gender.split('=');
                    if (genderArray.length > 1 && genderArray[1] === 'female') {
                        patientData += '&geschlecht=' + encodeURIComponent('W');
                    } else if (genderArray.length > 1 && genderArray[1] === 'male') {
                        patientData += '&geschlecht=' + encodeURIComponent('M');
                    } else {
                        patientData += '&geschlecht=' + encodeURIComponent('U');
                    }
                    patientData += '&strasse=' + encodeURIComponent(street.split('=')[0]);
                    patientData += '&plz=' + encodeURIComponent(postalCode.split('=')[0]);
                    patientData += '&ort=' + encodeURIComponent(city.split('=')[0]);
                    patientData += '&geburtsname=' + encodeURIComponent(birthName.split('=')[0]);
                    patientData += '&geburtsort=' + encodeURIComponent(birthCity.split('=')[0]);

                    ajax.ajaxCallDeferredExtended(data.url + '?_method=PUT', 'POST', patientData, false, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, false).done(function(data) {
                        if (ajax.ajaxSucceeded(data)) {
                            defer.resolve(true);
                        } else {
                            defer.reject();
                        }
                    });
                }
            } else {
                defer.reject();
            }
        });
    }).promise();
}

function mergePatientAndIDATData(idatData, patientData, matchData) {

    if (!utils.isUndefined(idatData)) {
        jQuery.each(idatData, function (key, value) {
            if (/_format$/.test(key)) {
                patientData[matchData[key.substr(0, key.indexOf('_format'))] + '_format'] = value;
            } else {
                patientData[matchData[key]] = value;
            }
        });
        patientData["age"] = utils.calculateAge(idatData.birth_date);
    }

    return patientData;
}

module.exports.loadPatientlist = loadPatientlist;
module.exports.getPatientlist = getPatientlist;
module.exports.setData = setData;
module.exports.resetForms = resetForms;
module.exports.loadExaminationList = loadExaminationList;
module.exports.getExaminationList = getExaminationList;
module.exports.loadAgreementList = loadAgreementList;
module.exports.checkEndingAgreements = checkEndingAgreements;
module.exports.addPatientToIDAT = addPatientToIDAT;
module.exports.addPatientToIDATWithPseudonym = addPatientToIDATWithPseudonym;
module.exports.changePatientInIDAT = changePatientInIDAT;
module.exports.mergePatientAndIDATData = mergePatientAndIDATData;
module.exports.loadIDATPatientListWithPseudonym = loadIDATPatientListWithPseudonym;
module.exports.setIntegrityAndCalculations = setIntegrityAndCalculations;
module.exports.loadIDATPatientList = loadIDATPatientList;
